import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/customer-validators';
import { SearchService } from 'src/app/services/search.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  public searchForm: FormGroup;
  public searching: boolean = false;
  public results:any=[];
  public visibleResults:any=[];
  public searched:boolean=false;
  public currentPage:number=1;
  public lastPage:number=1;
  public perPage:number=20;
  public slice1:number=0;
  public slice2:number=this.perPage;
  public filter:any=[];
  public roleIds:any=[];

  constructor(private searchService: SearchService) {
    this.searchForm = new FormGroup({
      'terms': new FormControl(null, [Validators.required, CustomValidators.validateTextField])
    });
    this.filter.type='all';
    this.filter.role_all=true;
    this.filter.role_vet=false;
    this.filter.role_nurse=false;
    this.filter.role_non=false;
    this.roleIds[1]='vet';
    this.roleIds[2]='nurse';
    this.roleIds[3]='non';
    this.roleIds[4]='pra';
    this.roleIds[5]='sup';
    this.roleIds[6]='stu';
  }

  ngOnInit() {
  }

  search(page, page2){
    this.results=[];
    this.searching = true;


    this.searchService.streamSearch(this.searchForm.get('terms').value,page2).subscribe((res:any)=>{
      res.forEach((item:any)=>{ this.results.push(item) });

      this.searchService.courseSearch(this.searchForm.get('terms').value,page).subscribe((res:any)=>{
        res.forEach((item:any)=>{ this.results.push(item) });
        this.searching= false;
        this.searched=true;
        this.visibleResults=this.results;
        this.sortPagination(this.results.length);
      });
    });
  }

  sortPagination(length:number)
  {
    this.lastPage=Math.ceil(length/this.perPage);
  }

  doFilterRoleAll()
  {
    if(this.filter.role_all)
    {
      this.filter.role_vet=false;
      this.filter.role_nurse=false;
      this.filter.role_non=false;
    }
    else
    {
      if(
        this.filter.role_vet==false
        && this.filter.role_nurse==false
        && this.filter.role_non==false
      )
      {
        this.filter.role_all=true;
      }
    }
    this.filterResults();
  }

  doFilter()
  {
    if(
      this.filter.role_all==false
      && this.filter.role_vet==false
      && this.filter.role_nurse==false
      && this.filter.role_non==false
    )
    {
      this.filter.role_all=true;
    }
    else if(
      this.filter.role_vet==true
      || this.filter.role_nurse==true
      || this.filter.role_non==true
    )
    {
      this.filter.role_all=false;
    }
    this.filterResults();
  }

  filterResults()
  {
    let tmpResults=[];
    this.results.forEach((result:any)=>{
      let include=true;
      // Deal with TYPE
      if(this.filter.type=='course')
      {
        if(!result.title) include=false;
      }
      if(this.filter.type=='series')
      {
        if(!result.name) include=false;
      }
      let includeRole=true;
      // Deal with ROLE
      if(!this.filter.role_all && !result.user_roles.length) includeRole=false;
      if(!this.filter.role_all && result.user_roles.length)
      {
        let subinclude=false;
        result.user_roles.forEach((role:any)=>{
          if(this.filter['role_'+this.roleIds[role.id]]) subinclude=true;
        });
        includeRole=subinclude;
      }
      if(include&&includeRole) tmpResults.push(result);
    });
    this.visibleResults=tmpResults;
    this.sortPagination(this.visibleResults.length);
  }

  nextPage(){
    this.currentPage++;
    this.sortSlices();
  }

  previousPage(){
    this.currentPage--;
    this.sortSlices();
  }

  sortSlices()
  {
    this.slice1=this.perPage*(this.currentPage-1);
    this.slice2=this.perPage*this.currentPage;
  }
}
